export class UnauthorizedError extends Error {}

export class MarketError extends Error {
  constructor(public readonly apiCode: string, public readonly apiMessage: string, public readonly apiDetails?: any) {
    super(apiMessage)
  }
}
